/**
 * 全局默认值模块
 * 用户登录时（页面刷新）触发 init，
 * 默认将用户的单位信息设为初始值
 * 设初始值时会同时保存到缓存中 前缀: __
 * 初始化时先判断是否已经有值，如果有则跳过
 */
import {formatUnitTree} from "@/utils/format"
import storage from "@/utils/storage"

const state = {
    unit: null,
    organ: null,
    area: null,
    product: null,

};

const actions = {
    init({dispatch, getters}, {userInfo}) {
        const {unit} = userInfo
        if ('Organs' === unit.type) {
            !getters.organ && dispatch({type: 'setDefault', payload: {organ: unit,unit: null}})
            // !getters.unit && dispatch({type: 'setDefault', payload: {unit: null}})
        } else {
            !getters.unit && dispatch({type: 'setDefault', payload: {unit}})
        }
        const area = {
            id: unit.areaId, name: unit.areaName,
            code: unit.areaCode, type: unit.areaType,
            lat: unit.lat, lng: unit.lng
        }
        !getters.area && dispatch({type: 'setDefault', payload: {area}})
    },
    setDefault({commit, dispatch}, {payload}) {
        commit('Success', payload);
    },

};

const getters = {
    unit: state => state.unit || storage.getCache('__unit'),
    organ: state => state.organ || storage.getCache('__organ'),
    area: state => state.area || storage.getCache('__area'),
    product: state => state.product || storage.getCache('__product'),
    all: (state, getter, modules, allGetters) => {
        const {unit, organ, area, product} = getter
        const unitOrOrgan=unit||organ
        return {unit, organ, area, product,unitOrOrgan}
    },
};

const mutations = {
    Success(state, payload) {
        Object.keys(payload).map(key => {
            storage.setCache('__' + key, payload[key])
            state[key] = payload[key]
        })
    }
};

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
};
